exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar[data-v-60d3825e]{width:50px;height:50px;border-radius:100vh;overflow:hidden;margin-right:16px}.label-zublu[data-v-60d3825e]{font-size:12px;padding:4px 8px 2px;border-radius:2px;background:#45aab5;color:#fff;margin-left:10px}.loader[data-v-60d3825e]{border:2px solid #dbdbdb;border-radius:50%;border-top:2px solid #000;width:20px;height:20px;animation:spin 2s linear infinite}", ""]);

// exports
